import * as React from "react";
import * as QueryString from "query-string";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { push } from "connected-react-router";
// API
import UserAPI from "@vingle/wtf-sdk/api/user";
// components
import {
  FormattedMessage,
  WrappedComponentProps,
  injectIntl,
} from "react-intl";
import SolidButton from "common/components/solidButton";
import PageUpdater from "@vingle/wtf-sdk/components/pageUpdater";
import SignUpNavbar from "common/components/signupNavbar";
import SolidReasonInput from "common/components/solidReasonInput";
// actions
import { pushToast, notifyError } from "@vingle/wtf-sdk/actions/toast";
// interface
import { AppDispatch } from "app/store";
// styles

import { VingleURL } from "@vingle/wtf-sdk/url";
const styles = require("./newPassword.scss");

interface IProps
  extends RouteComponentProps<Vingle.IMatchParams>,
    WrappedComponentProps {
  dispatch: AppDispatch;
}

interface IState {
  resetToken: string;
  newPassword: string;
  rePassword: string;
  isMatch: boolean;
}

class NewPassword extends React.PureComponent<IProps, IState> {
  public state = {
    resetToken: "",
    newPassword: "",
    rePassword: "",
    isMatch: false,
  };

  public componentDidMount() {
    const { location } = this.props;
    const qs = QueryString.parse(location.search);
    this.setState({
      resetToken: (qs.reset_password_token as string) || "",
    });
  }

  public render() {
    return (
      <div className={styles.rootWrapper}>
        <PageUpdater title="New password" />
        <SignUpNavbar />
        {this.renderPasswordForm()}
      </div>
    );
  }

  private readonly renderPasswordForm = () => {
    const { intl } = this.props;
    const { newPassword, rePassword, isMatch } = this.state;
    return (
      <div className={styles.form}>
        <div className={styles.title}>
          <FormattedMessage id="new_password.title" />
        </div>
        <SolidReasonInput
          inputType="password"
          wrapperClassName={styles.inputWrapper}
          value={newPassword}
          onChange={this.handlePasswordChange}
          placeholder={intl.formatMessage({
            id: "new_password.input.placeholder",
          })}
          isDebounce={false}
          autoFocus={true}
        />
        <SolidReasonInput
          inputType="password"
          wrapperClassName={styles.inputWrapper}
          value={rePassword}
          onChange={this.handleRePasswordChange}
          placeholder={intl.formatMessage({
            id: "new_password.input.re.placeholder",
          })}
          isDebounce={false}
          autoFocus={false}
        />
        <SolidButton
          disabled={!isMatch}
          disabledClassName={styles.disable}
          onClick={this.onSubmit}
          className={styles.submitButton}
          buttonText={<FormattedMessage id="new_password.button.submit" />}
        />
      </div>
    );
  };

  private readonly handlePasswordChange: React.ChangeEventHandler<
    HTMLInputElement
  > = e => {
    const textValue = e.currentTarget.value;
    this.setState({
      newPassword: textValue,
    });
  };

  private readonly handleRePasswordChange: React.ChangeEventHandler<
    HTMLInputElement
  > = e => {
    const textValue = e.currentTarget.value;
    const validLength =
      this.state.newPassword.length >= 6 && textValue.length >= 6;
    this.setState({
      rePassword: textValue,
      isMatch: this.state.newPassword === textValue && validLength,
    });
  };

  private readonly onSubmit = async () => {
    const { dispatch } = this.props;
    const { resetToken, newPassword } = this.state;
    if (!resetToken) {
      this.alertInvalidToken();
      return;
    }

    try {
      await UserAPI.resetPassword({
        token: resetToken,
        password: newPassword,
      });
      dispatch(push(new VingleURL.Home().toString()));
    } catch (err) {
      // special case
      if (
        err.response.data &&
        err.response.data.error.code === "INVALID_TOKEN"
      ) {
        this.alertInvalidToken();
      } else {
        dispatch(notifyError(err));
      }
    }
  };

  private readonly alertInvalidToken = () => {
    this.props.dispatch(
      pushToast({
        type: "DANGER",
        messageId: "new_password.error.invalid_reset_token",
      }),
    );
  };
}

export default connect()(injectIntl(NewPassword));
